<template>
  <div>
    <div class="titlebar z-10 h-16 bg-gray-300 flex justify-between fixed top-0 left-0 w-full">
      <div class="flex justify-center items-center ml-5">
        <img class=" opacity-50" src="../ics/home.svg" alt="">
      </div>
      <div class="flex justify-center items-center">
        <!-- <LoaderUI2></LoaderUI2> -->
        <span class="hello-flash" v-if="PostState.loading.feed">
          Refreshing....
        </span>
        <span v-else-if="me">
          @{{ me.user.username }}
        </span>
      </div>
      <div class="flex justify-center items-center mr-5 cursor-pointer" @click="$router.push('/app/menu')">
        <img src="../ics/menuham.svg" alt="">
      </div>
    </div>
    <div class="h-16"></div>

    <div class="max-w-xl mx-auto">
      <LoaderUI v-if="PostState.loading.feed" class="fixed loaderUI z-50"></LoaderUI>
      <Feed></Feed>
      <!-- <Post :key="post" v-for="post in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]"></Post> -->
    </div>

    <LeftMenu></LeftMenu>

    <div class="h-16"></div>
    <div class="bottombar h-16 bg-gray-300 sh flex justify-between fixed bottom-0 left-0 w-full">
      <div class="flex justify-center items-center ml-5">
        <img src="../ics/plus.svg" alt="" class="cursor-pointer" @click="$router.push('/app/composer')">
      </div>
      <div class="flex justify-center items-center">
        <img src="../ics/bell.svg" alt="" class="cursor-pointer" @click="$router.push('/app/notification')">
      </div>
      <div class="flex justify-center items-center mr-5">
        <img src="../ics/reload.svg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import * as API from '../../api/api'
import Posts from '../../api/posts'
export default {
  components: {
    Feed: require('../uis-feed/Feed.vue').default,
    LoaderUI: require('../uis/LoaderUI.vue').default,
    LeftMenu: require('../uis/LeftMenu.vue').default
    // LoaderUI2: require('../uis/LoaderUI2.vue').default
    // Post: require('../uis-post/Post.vue').default
  },
  computed: {
    me () {
      return API.state.me
    }
  },
  methods: {
  },
  data () {
    return {
      PostState: Posts.state
    }
  },
  async mounted () {
  }
}
</script>

<style lang="postcss">
.loaderUI{
  top: 60px;
  right: 20px;
}
</style>
